import { createContext } from 'react';

import type { ContractFilterOptions } from '@/types/contract';

export interface ContractsGridContextInterface {
  expandedIds: Set<string>;
  filterOptions: ContractFilterOptions | undefined;
  getParam: (key: string) => string;
  setParam: (key: string, value: string) => void;
  toggleExpanded: (id: string) => void;
}

// Shared with the contracts grid's cell renderers and floating filters, which AG Grid renders
// inside this React tree, so they re-render with the page's URL and expansion state.
const ContractsGridContext = createContext<ContractsGridContextInterface>({
  expandedIds: new Set(),
  filterOptions: undefined,
  getParam: () => '',
  setParam: () => undefined,
  toggleExpanded: () => undefined
});

export default ContractsGridContext;
